import './page-tips.css';
import React, { useEffect, useState } from 'react';
import { getTips, updateTips } from '../../services/service-tips';
import { serviceAreas } from '../../services/service-areas';
import appState from '../../state/AppStateContainer';
import BackButton from '../../components/shared/BackButton/BackButton';
import AppLayout from '../../components/layout/app-layout/app-layout';
import ScrollToTop from '../scroll-to-top/scroll-to-top';
import Editor from '../../components/shared/Editor/Editor';
import { useTranslation } from 'react-i18next';

const PageTips = ({ match }) => {
  const [t] = useTranslation('projects', { keyPrefix: 'tips' });
  const [areaName, setAreaName] = useState('');
  const [editing, setEditing] = useState(false);
  const [prevHTML, setPrevHTML] = useState('');
  const [tips, setTips] = useState('');

  useEffect(() => {
    serviceAreas.getArea(match.params.areaSlug).then(setAreaName);
    getTips(match.params.areaSlug).then((html) => setTips(html));
  }, [])

  const onSave = () => {
    updateTips({ areaSlug: match.params.areaSlug, tips });
    setEditing(false);
  }
  const onCancel = () => {
    setTips(prevHTML);
    setEditing(false);
  }

  const toggleEditing = () => {
    setEditing(oldState => {
      if (!oldState) {
        setPrevHTML(tips);
      }
      return !oldState;
    });
  }

  return (
    <AppLayout
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <BackButton to={`/projects/${match.params.project}/${match.params.areaSlug}`} />
          <h3>{t('pageTitle', 'Upphandlingstips för {{areaName}}', { areaName })}</h3>
        </div>
      }
    >
      <ScrollToTop />
      <div className={`tipsContainer ${editing ? 'editing' : ''}`}>
        <div className='header'>
          {appState.isWriteAccessRole() && <button className='ar-button' onClick={toggleEditing}>{t('button.edit', 'Redigera')}</button>}
        </div>
        <Editor value={tips} onChange={setTips} hideToolbar={!editing} isDisabled={!editing} />
        <div className='buttonDiv'>
          <button className='ar-button secondary' onClick={onCancel}>{t('button.cancel', 'Avbryt')}</button>
          <button className='ar-button' onClick={onSave}>{t('button.save', 'Spara')}</button>
        </div>
      </div>
    </AppLayout>
  );
}

export default PageTips;
